require("@rails/ujs").start()
require("@rails/activestorage").start()

import 'core-js/stable' // ES6 polyfills
import 'unpoly'
import 'moment'

import 'bootstrap'
import 'tempusdominus-bootstrap-4'
import 'bootstrap-daterangepicker'
import 'bootstrap4-toggle/js/bootstrap4-toggle.min'
import 'bootstrap-select/dist/js/bootstrap-select.min'
import '@fortawesome/fontawesome-free/js/all'
import 'chartkick/chart.js'
import 'bootstrap-autocomplete/dist/latest/bootstrap-autocomplete'
import 'bs-stepper'
import 'sortablejs'
import print from 'print-js'

import { Dropzone } from "dropzone";
Dropzone.autoDiscover = false;

// JavaScript
let webpackContext = require.context('../javascripts', true, /\.js(\.erb)?$/)
for(let key of webpackContext.keys()) { webpackContext(key) }
window.moment = moment

// Images
require.context('../images', true, /\.(?:png|jpg|gif|ico|svg)$/)

// Stylesheets
import '../stylesheets/custom_bootstrap'
import '../stylesheets/unpoly.sass'
import 'dropzone/dist/dropzone.css'
import 'bs-stepper/dist/css/bs-stepper.min.css'
import 'print-js/dist/print.css'



//require.context('../stylesheets/theme', true, /\.s[ac]ss(\.erb)?$/)
require.context('../stylesheets/blocks', true, /\.s[ac]ss(\.erb)?$/)
require.context('../stylesheets/ext', true, /\.s?[ac]ss(\.erb)?$/)
require.context('../stylesheets/general', true, /\.s?[ac]ss(\.erb)?$/)